// extracted by mini-css-extract-plugin
export default {"ppMain":"PrivacyPolicyPage_ppMain__kyRn9","ppNav":"PrivacyPolicyPage_ppNav__hJrpn","heading":"PrivacyPolicyPage_heading__HNcyO","content":"PrivacyPolicyPage_content__GaLrv"};